import { InputType, ContractCondition, ContractType } from '../../js/constants';
import { getFakeUrl, fakeAbbr } from '../../_helpers/fake-url';
import * as http from '../../js/service';
import { isManagement } from '../../js/authorization';


export default function () {
    return {
        url: "/case/{caseId}/contract/amc",
        rows: [
            [
                {
                    name: "agreementNo",
                    text: "เลขที่สัญญาเงินกู้/บัตรเครดิต",
                    type: InputType.text,
                    disabled: true
                },
                {
                    name: "contractDate",
                    text: "วันที่ทำสัญญา",
                    type: InputType.datePicker,
                },
                {
                    type: InputType.offset,
                },
                {
                    type: InputType.offset,
                },

            ],
            [
                {

                    name: "creditLine",
                    text: "วงเงินกู้ยืม",
                    type: InputType.number,
                    decimal: 2,
                },
                {

                    name: "principal",
                    text: "ต้นเงิน",
                    type: InputType.number,
                    decimal: 2,
                    // disabledIf: (context) => {
                    //     if (isManagement()) {
                    //         return false;
                    //     }

                    //     return true;
                    // },
                },
                {
                    name: "interest",
                    text: "ดอกเบี้ย",
                    type: InputType.number,
                    decimal: 2,
                    // disabledIf: (context) => {
                    //     if (isManagement()) {
                    //         return false;
                    //     }

                    //     return true;
                    // }
                },
                {
                    name: "otherFee",
                    text: "ค่าธรรมเนียมอื่นๆ",
                    type: InputType.number,
                    decimal: 2,
                    // disabledIf: (context) => {
                    //     if (isManagement()) {
                    //         return false;
                    //     }

                    //     return true;
                    // }
                },
                {
                    type: InputType.offset,
                },
                {
                    type: InputType.offset,
                },
            ],
            // line 3
            [
                {
                    name: "total",
                    text: "ยอดหนี้รวมก่อนฟ้อง",
                    type: InputType.label,
                    rule: {
                        number: true
                    },
                    decimal: 2,
                    disabled: true
                },
                {
                    name: "totalAmountAtPlaintDate",
                    text: "ยอดหนี้รวม ณ วันฟ้อง",
                    type: InputType.label,
                    rule: {
                        number: true
                    },
                    decimal: 2,
                    disabled: true
                },
                {
                    type: InputType.offset,
                },
                {
                    type: InputType.offset,
                },
                {
                    type: InputType.offset,
                },
                {
                    type: InputType.offset,
                },

            ],
            [
                {
                    type: InputType.section
                }
            ],
            [
                {
                    name: "contractType",
                    text: "ประเภทสัญญา",
                    labelPath: 'text',
                    type: InputType.label,
                },
                {
                    name: "interestRatePerYear",
                    text: "ดอกเบี้ยต่อปี",
                    type: InputType.number,
                    decimal: 2,
                    rule: {
                        required: true,
                    },
                    suffixText: "%",
                },
                {
                    name: "lastPaidDate",
                    text: "ชำระล่าสุดวันที่",
                    type: InputType.datePicker,
                },
                {
                    name: "lastPaidAmount",
                    text: "จำนวนที่จ่ายครั้งล่าสุด",
                    type: InputType.number,
                    decimal: 2,
                },
                {
                    type: InputType.offset,
                },
                {
                    type: InputType.offset,
                },
            ],
            [
                {
                    name: "installments",
                    text: "จำนวนงวด",
                    decimal: 0,
                    type: InputType.number,
                    rule: {
                        min_value: 1,
                        max_value: 120,
                    },
                    showIf: (context) => {
                        const model = context.model;

                        if (model.contractType && [ContractType.AMC_KBANK_PERSONAL_LOAN, ContractType.AMC_SCB_PERSONAL_LOAN].includes(model.contractType.id)) {
                            return true;
                        }

                        return false;
                    }
                },
                {
                    name: "paymentPerMonthIncludeVAT",
                    text: "ยอดผ่อนชำระรายเดือน",
                    type: InputType.number,
                    decimal: 2,
                    showIf: (context) => {
                        const model = context.model;

                        if (model.contractType && [ContractType.AMC_KBANK_PERSONAL_LOAN, ContractType.AMC_SCB_PERSONAL_LOAN].includes(model.contractType.id)) {
                            return true;
                        }

                        return false;
                    }
                },
                {
                    type: InputType.offset,
                },
                {
                    type: InputType.offset,
                },
                {
                    type: InputType.offset,
                },
                {
                    type: InputType.offset,
                },
            ],
        ]
    };
}